<template>
  <PageWrapper>
    <template #title> سفارشات ثبت شده با این کد </template>
    <CustomTable
      v-if="ordersList"
      :pageNumber="masterDiscountCodeOrderFilters.pageNumber"
      :count="masterDiscountCodeOrderFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="ordersList"
      @changePage="changePage"
    >
      <template #status="data">
        <BBadge
          :variant="handleStatusChipColor(data.item.status)"
          style="white-space: nowrap"
        >
          {{ orderStatuses[data.item.status] }}
        </BBadge>
      </template>
      <template #sumPrice="data">
        <span style="white-space: nowrap">
          {{
            data.item.sumPrice
              ? Intl.NumberFormat("en-US").format(data.item.sumPrice) + " تومان"
              : "-"
          }}
        </span>
      </template>
      <template #sumPriceAfterDiscount="data">
        <span style="white-space: nowrap">
          {{
            data.item.sumPriceAfterDiscount
              ? Intl.NumberFormat("en-US").format(
                  data.item.sumPriceAfterDiscount
                ) + " تومان"
              : "-"
          }}
        </span>
      </template>
      <template #createDate="data">
        <div style="white-space: nowrap">
          {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
          -
          {{
            new Date(data.item.createDate).toLocaleTimeString("fa-IR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          }}
        </div>
      </template>
      <template #userFullName="data">
        <b-link :to="`/users/${data.item.userId}`" style="white-space: nowrap">
          {{ data.item.userFullName }}
        </b-link>
      </template>
      <template #actions="data">
        <b-link :to="`/orders/${data.item.orderId}`">
          <FeatherIcon class="text-primary" icon="EyeIcon" size="20" />
        </b-link>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  props: {
    masterDiscountCodeId: {
      type: [String, Number],
      default: null,
    },
  },
  mounted() {
    this.getAllOrdersOfMasterDiscount();
  },
  data() {
    return {
      isLoading: false,
      ordersList: null,
      totalCount: null,
      masterDiscountCodeOrderFilters: {
        pageNumber: 1,
        count: 10,
        masterCodeDiscountId: null,
      },
      orderStatuses: {
        1: "ثبت شده",
        2: "پرداخت شده",
        3: "ارسال شده",
        4: "تحویل شده",
        5: "کنسل شده",
      },
      tableColumns: [
        {
          label: "شناسه سفارش",
          key: "orderId",
        },
        {
          label: "وضعیت سفارش",
          key: "status",
        },
        {
          label: "کاربر",
          key: "userFullName",
        },
        {
          label: "مبلغ سفارش",
          key: "sumPrice",
        },
        {
          label: "مبلغ سفارش بعد از تخفیف",
          key: "sumPriceAfterDiscount",
        },
        {
          label: "تاریخ ثبت سفارش",
          key: "createDate",
        },
        {
          label: "توضیحات سفارش",
          key: "description",
        },
        {
          label: "عملیات",
          key: "actions",
        },
      ],
    };
  },
  methods: {
    changePage(pageNumber) {
      this.masterDiscountCodeOrderFilters.pageNumber = pageNumber;
      this.getAllOrdersOfMasterDiscount();
    },
    handleStatusChipColor(status) {
      switch (status) {
        case 1:
          return "warning";
        case 2:
          return "success";
        case 5:
          return "danger";
      }
    },
    async getAllOrdersOfMasterDiscount() {
      try {
        this.masterDiscountCodeOrderFilters.masterCodeDiscountId =
          this.masterDiscountCodeId;
        this.isLoading = true;
        let _this = this;
        let getOrdersOfMasterDiscountCode = new GetOrdersOfMasterDiscountCode(
          _this
        );
        getOrdersOfMasterDiscountCode.setRequestParamDataObj(
          _this.masterDiscountCodeOrderFilters
        );
        await getOrdersOfMasterDiscountCode.fetch((res) => {
          _this.ordersList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    CustomTable,
    BLink,
    BBadge,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import { BLink, BBadge } from "bootstrap-vue";
import { GetOrdersOfMasterDiscountCode } from "@/libs/Api/Order";
</script>
